export enum BrandFontTypes {
  CUSTOM = 'custom',
  GOOGLE = 'google'
}
